const contents = {
  HEADER: {
    MENU: {
      SEARCH: "SEARCH",
      ABOUT_US: "ABOUT US",
      OPINION: "OPINION",
      SIGN_IN: "BUSINESS SIGN IN",
      MANUAL: "MANUAL"
    }
  },
  FOOTER: {
    MENU: {
      PRIVACY_POLICY: "PRIVACY POLICY",
      TERMS_OF_SERVICE: "LEGAL TERMS",
      COOKIE_POLICY: "COOKIE POLICY"
    }
  },
  HOME: {
    TITLE: "Food safety program",
    SUBTITLE: "Find this badge in your trusted establishments",
    VIDEO: "Click here to see video"
  },
  SEARCH: {
    TITLE: "SEARCH",
    CONTENT:
      "Are you going to eat out? Find out if the restaurant, hotel or caterer has a good high hygiene level and follows the quality standards set by the Official Control.",
    FILTERS: {
      NAME: "Name",
      ADDRESS: "Address",
      SCORE: "Score"
    },
    RESULTS: {
      MORE_INFO: "MORE INFO",
      VIEW_MORE: "VIEW MORE"
    }
  },
  ABOUT_US: {
    TITLE: "About us",
    CONTENT: {
      P1:
        "PUBLIC HEALTH is the area in the Balearic Islands Government responsible for ensuring and promoting food safety.",
      P2:
        "The QxQ PROGRAM is the result of research and technical consensus to empower companies in the food chain and make their hygiene processes transparent to facilitate consumer choice."
    },
    Q1: {
      TITLE: "Q for Quantification",
      CONTENT:
        "It refers to the verification of self-control carried out by food companies, with a score from 1 (very poor) to 5 (excellent), which will be agreed upon by external validators and Public Health technicians."
    },
    Q2: {
      TITLE: "Q for Qualification",
      CONTENT:
        "It refers to the fact that companies and consumers, locals and tourists, can comment and qualify the strategy of the QxQ Program for the continuous improvement of food safety in the Balearic Islands."
    }
  },
  OPINION: {
    TITLE: "Your opinion",
    CONTENT:
      "How do you see this score? Do you have suggestions about the project? Send us a message with your comments and help us to improve!",
    FORM: {
      NAME: "Name",
      EMAIL: "Email",
      MESSAGE: "Message",
      SUBMIT: "SEND"
    },
    FEEDBACK: "Thank you for sharing your opinion with us!"
  },
  FACILITY: {
    RELATED: "Can also be of interest:",
    ADDRESS: "Address",
    CONTACT: "Contact",
    EXPLAINATION:
      "* The score evaluates the last self-control verification made by the establishment and agreed by the technicians with due diligence. In any case, the company that manages the establishment is responsible for ensuring compliance with all food safety requirements."
  },
  BLOCK: {
    FIRST: {
      1: "The premises, facilities and equipment of this establishment are not suitable for the activities that are being carried out, its maintenance and cleanliness is insufficient and the use that is given does not guarantee the food safety of the products that are being handled.",
      2: "The premises, facilities and equipment of this establishment must be updated and its level of maintenance and cleanliness must be improved to avoid risks in the food safety of the products that are being handled.",
      3: "The premises, facilities and equipment of this establishment allow acceptable conditions for food handling, although there is a margin of improvement in some aspects of maintenance and cleanliness.",
      4: "The premises, facilities and equipment of this establishment allow adequate conditions for food handling, with a very good state of maintenance and cleanliness and its use is correct.",
      5: "The premises, facilities and equipment of this establishment are suitable for the food handling, with a very excellent level of maintenance and cleanliness and its use is optimal."
    },
    SECOND: {
      1: "Food processing and handling practices do not allow for the preparation of safe food for the consumer. Food handlers need to be adequately trained.",
      2: "Food processing and handling practices must be improved in order to prepare safe food for the consumer. The training of food handlers should be improved.",
      3: "Food processing and handling practices allow the food to be prepared in an acceptable way. However, there are important points of improvement that must be taken into consideration.",
      4: "Food processing and handling practices are adequate. The risk control measures are sufficient and the training of the food handlers is correct.",
      5: "Food processing and handling practices are excellent. The risk control measures are optimal and the food handlers are properly trained."
    },
    THIRD: {
      1: "The auto-control plans and records do not correspond to reality, do not cover all the activities of the establishment and are not properly completed, so they do not allow for the monitoring of the activities that are being developed or trust in the management Procedures.",
      2: "Some of the auto-control plans and registers do not correspond to the reality, do not cover all the activities of the establishment, or are not properly completed, so they do not allow for a good follow-up of the activities that are being developed or trust in the management.",
      3: "The plans and records of auto-control correspond to the reality, cover all the activities of the establishment and are duly completed, allowing for the ability to keep track of the activities that are being developed. However, there are aspects in which plans or records could be improved.",
      4: "The auto-control plans and registers correspond to reality, cover all the activities of the establishment and are duly completed, allowing the monitoring of the activities that are being developed.",
      5: "The auto-control plans and registers correspond to the reality, cover all the activities of the establishment and are duly completed, allowing an optimal follow-up of the activities that are being developed and a high confidence in their management procedures."
    }
  },
  SCORES: {
    5: "EXCELENT",
    4: "GOOD",
    3: "REGULAR",
    2: "POOR",
    1: "VERY POOR"
  },
  UPDATED: "UPDATED"
};

export default contents;



// WEBPACK FOOTER //
// ./src/services/translation/contents.en_GB.js